import { View } from './view'

export const Video = View
